import { useSelector } from 'react-redux';

export const FullUI = () => useSelector(state => state.ui)
export const UIWaiting = () => useSelector(state => state.ui.waiting)
